<template>
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.916 0.684H8.308L0.947999 7.948L8.308 15.212H12.916L5.524 7.948L12.916 0.684Z"
      fill="#888b8d"
    />
  </svg>
</template>
